import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { loadReportsParams, OrderHistoryResultModel } from "@tKgpco/Services/ReportsService";
import { ProductMultipleQtyState } from "@tKgpco/Store/Data/ProductMultipleQty/ProductMultipleQtyState";
import { ReportHistoryState } from "@tKgpco/Store/Data/ReportHistory/ReportHistoryState";
import { Draft } from "immer";

const initialState: ProductMultipleQtyState = {
    showMinimumQtyError: false,
    showMultipleQtyError: false,
};

export const reducer = {
    "Custom/Product/DispatchMinimumQtyError": (draft: Draft<ProductMultipleQtyState>, action: { param: boolean }) => {
        draft.showMinimumQtyError = action.param;
    },

    "Custom/Product/DispatchMultipleSaleQtyError": (
        draft: Draft<ProductMultipleQtyState>,
        action: { param: boolean },
    ) => {
        draft.showMultipleQtyError = action.param;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
